import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import Button from '../../button';
import Icon from '../../icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const FilterPanel = ({ elmId = 'filter_panel', isDrawer = false, showCloseButton = false, onOpen, onReset, children, }) => {
    const content = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { elmId: `${elmId}_content` });
        }
        return child;
    });
    const containerRef = useRef(null);
    const sentinelRef = useRef(null);
    const [atBottom, setAtBottom] = useState(false);
    const [hasOverflow, setHasOverflow] = useState(false);
    useEffect(() => {
        const container = containerRef.current;
        const checkOverflow = () => {
            if (container) {
                const isOverflowing = container.scrollHeight > container.clientHeight;
                setHasOverflow(isOverflowing);
            }
        };
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [content]);
    useEffect(() => {
        const container = containerRef.current;
        const sentinel = sentinelRef.current;
        if (!container || !sentinel || !hasOverflow) {
            setAtBottom(!hasOverflow);
            return;
        }
        const observer = new IntersectionObserver(([entry]) => {
            setAtBottom(entry.isIntersecting);
        }, {
            root: container,
            rootMargin: '0px 0px -1px 0px',
            threshold: 0,
        });
        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [hasOverflow]);
    useEffect(() => {
        const container = containerRef.current;
        if (!container || !hasOverflow) {
            return;
        }
        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = container;
            const top = Number(scrollTop) || 0;
            const height = Number(clientHeight) || 0;
            const totalHeight = Number(scrollHeight) || 0;
            const isAtBottom = top + height >= totalHeight - 5;
            setAtBottom(isAtBottom);
        };
        container.addEventListener('scroll', handleScroll, { passive: true });
        return () => container.removeEventListener('scroll', handleScroll);
    }, [hasOverflow, content]);
    return (_jsxs("div", { className: cx('panel', {
            'no-overflow': !hasOverflow,
            'at-bottom': atBottom,
            'drawer-panel': isDrawer,
        }), children: [showCloseButton && (_jsx(Icon, { "data-elm-id": `${elmId}_close_button`, className: cx('close-button'), name: 'times', iconStyle: 'regular', fitted: true, size: 'large', onClick: () => onOpen(false) })), _jsxs("div", { ref: containerRef, className: cx('content', { 'drawer-content': isDrawer }), children: [_jsx("div", { children: content }), _jsx("div", { ref: sentinelRef, className: cx('sentinel') })] }), _jsxs("div", { className: cx({ 'footer-container': isDrawer }), children: [isDrawer && _jsx("hr", {}), _jsxs("div", { className: cx('footer', { 'drawer-footer': isDrawer }), children: [_jsx(Button, { role: 'tertiary', "data-elm-id": `${elmId}_reset_button`, className: cx('reset-button'), onClick: onReset, children: isDrawer ? 'Reset all filters' : 'Reset' }), _jsx(Button, { "data-elm-id": `${elmId}_done_button`, role: 'primary', className: cx('done-button'), onClick: () => onOpen(false), children: "Done" })] })] })] }));
};
export default FilterPanel;
//# sourceMappingURL=index.js.map